import type { Agent } from "../types/platform";
import { LAYER_RADII, posOnCircle } from "../hooks/useActiveNode";

export function AgentNode({
  agent,
  index,
  total,
  isActive,
  isPinned,
  isConnected,
  onHover,
  onClick
}: {
  agent: Agent;
  index: number;
  total: number;
  isActive: boolean;
  isPinned: boolean;
  isConnected: boolean;
  onHover: (agent: Agent) => void;
  onClick: (agent: Agent) => void;
}) {
  const p = posOnCircle(index, total, LAYER_RADII.agent);
  const Icon = agent.icon;

  const bg = isActive
    ? "#F28132"
    : isConnected
      ? "rgba(242,129,50,0.14)"
      : "rgba(255,255,255,0.08)";
  const border = isActive
    ? "#F28132"
    : isConnected
      ? "rgba(242,129,50,0.70)"
      : "rgba(255,255,255,0.25)";
  const shadow = isActive
    ? "0 0 30px rgba(242,129,50,0.5)"
    : isConnected
      ? "0 0 18px rgba(242,129,50,0.35)"
      : "none";
  const iconColor = isActive
    ? "#fff"
    : isConnected
      ? "#F28132"
      : "rgba(255,255,255,0.75)";
  const labelColor = isActive
    ? "#fff"
    : isConnected
      ? "#F28132"
      : "rgba(255,255,255,0.55)";

  return (
    <button
      type="button"
      aria-label={`Agent: ${agent.name}`}
      aria-pressed={isPinned}
      onMouseEnter={() => onHover(agent)}
      onFocus={() => onHover(agent)}
      onClick={() => onClick(agent)}
      className="absolute outline-none"
      style={{
        left: `${p.x}%`,
        top: `${p.y}%`,
        transform: "translate(-50%, -50%)"
      }}
    >
      <div className="flex flex-col items-center">
        <div
          className="flex items-center justify-center rounded-full transition-all duration-300"
          style={{
            width: isActive ? 52 : 44,
            height: isActive ? 52 : 44,
            backgroundColor: bg,
            border: `1px solid ${border}`,
            boxShadow: shadow,
            backdropFilter: "blur(8px)"
          }}
        >
          <Icon
            size={isActive ? 22 : 18}
            color={iconColor}
            strokeWidth={1.5}
          />
        </div>
        <div
          className="absolute whitespace-nowrap text-[10px] uppercase tracking-[0.15em] transition-colors duration-300"
          style={{
            top: "100%",
            marginTop: 8,
            color: labelColor,
            fontWeight: 500
          }}
        >
          {agent.name}
        </div>
      </div>
    </button>
  );
}
